import { fontOptions } from "./model";

export function AlbumTitle({ name, createdAt, fontFamily }: { name: string; createdAt: string; fontFamily?: string | null }) {
  const date = new Date(createdAt);
  const validDate = !Number.isNaN(date.getTime());
  return (
    <span className="album-title-row" style={{ fontFamily: fontOptions.find(font => font.value === fontFamily)?.css }}>
      <strong title={name}>{name}</strong>
      {validDate && <time dateTime={date.toISOString()} title={date.toLocaleString()}>
        Created {date.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" })}
      </time>}
    </span>
  );
}
